import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0 .667C0 .298.298 0 .667 0h10.666a.667.667 0 1 1 0 1.333H.667A.667.667 0 0 1 0 .667M0 3.63c0-.369.298-.667.667-.667h10.666a.667.667 0 1 1 0 1.333H.667A.667.667 0 0 1 0 3.63m0 2.963c0-.369.298-.667.667-.667h10.666a.667.667 0 1 1 0 1.333H.667A.667.667 0 0 1 0 6.593m0 2.963c0-.369.298-.667.667-.667h8a.667.667 0 0 1 0 1.333h-8A.667.667 0 0 1 0 9.556"
    }, null, -1)
  ]))]))
}
export default { render: render }